/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LogInImport } from './routes/log-in'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedReportsImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedAssertionRouteImport } from './routes/_authenticated/assertion/route'
import { Route as AuthenticateddashboardIndexImport } from './routes/_authenticated/(dashboard)/index'
import { Route as AuthenticatedReportReportIdImport } from './routes/_authenticated/report/$reportId'
import { Route as AuthenticatedProcessProcessIdImport } from './routes/_authenticated/process/$processId'
import { Route as AuthenticatedAssertiondashboardIndexImport } from './routes/_authenticated/assertion/(dashboard)/index'
import { Route as AuthenticatedAssertionReportReportIdImport } from './routes/_authenticated/assertion/report/$reportId'
import { Route as AuthenticatedAssertionProcessProcessIdImport } from './routes/_authenticated/assertion/process/$processId'

// Create/Update Routes

const LogInRoute = LogInImport.update({
  id: '/log-in',
  path: '/log-in',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedReportsRoute = AuthenticatedReportsImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedAssertionRouteRoute =
  AuthenticatedAssertionRouteImport.update({
    id: '/assertion',
    path: '/assertion',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticateddashboardIndexRoute =
  AuthenticateddashboardIndexImport.update({
    id: '/(dashboard)/',
    path: '/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedReportReportIdRoute =
  AuthenticatedReportReportIdImport.update({
    id: '/report/$reportId',
    path: '/report/$reportId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedProcessProcessIdRoute =
  AuthenticatedProcessProcessIdImport.update({
    id: '/process/$processId',
    path: '/process/$processId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedAssertiondashboardIndexRoute =
  AuthenticatedAssertiondashboardIndexImport.update({
    id: '/(dashboard)/',
    path: '/',
    getParentRoute: () => AuthenticatedAssertionRouteRoute,
  } as any)

const AuthenticatedAssertionReportReportIdRoute =
  AuthenticatedAssertionReportReportIdImport.update({
    id: '/report/$reportId',
    path: '/report/$reportId',
    getParentRoute: () => AuthenticatedAssertionRouteRoute,
  } as any)

const AuthenticatedAssertionProcessProcessIdRoute =
  AuthenticatedAssertionProcessProcessIdImport.update({
    id: '/process/$processId',
    path: '/process/$processId',
    getParentRoute: () => AuthenticatedAssertionRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/log-in': {
      id: '/log-in'
      path: '/log-in'
      fullPath: '/log-in'
      preLoaderRoute: typeof LogInImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/assertion': {
      id: '/_authenticated/assertion'
      path: '/assertion'
      fullPath: '/assertion'
      preLoaderRoute: typeof AuthenticatedAssertionRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/process/$processId': {
      id: '/_authenticated/process/$processId'
      path: '/process/$processId'
      fullPath: '/process/$processId'
      preLoaderRoute: typeof AuthenticatedProcessProcessIdImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/report/$reportId': {
      id: '/_authenticated/report/$reportId'
      path: '/report/$reportId'
      fullPath: '/report/$reportId'
      preLoaderRoute: typeof AuthenticatedReportReportIdImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/(dashboard)/': {
      id: '/_authenticated/(dashboard)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticateddashboardIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/assertion/process/$processId': {
      id: '/_authenticated/assertion/process/$processId'
      path: '/process/$processId'
      fullPath: '/assertion/process/$processId'
      preLoaderRoute: typeof AuthenticatedAssertionProcessProcessIdImport
      parentRoute: typeof AuthenticatedAssertionRouteImport
    }
    '/_authenticated/assertion/report/$reportId': {
      id: '/_authenticated/assertion/report/$reportId'
      path: '/report/$reportId'
      fullPath: '/assertion/report/$reportId'
      preLoaderRoute: typeof AuthenticatedAssertionReportReportIdImport
      parentRoute: typeof AuthenticatedAssertionRouteImport
    }
    '/_authenticated/assertion/(dashboard)/': {
      id: '/_authenticated/assertion/(dashboard)/'
      path: '/'
      fullPath: '/assertion/'
      preLoaderRoute: typeof AuthenticatedAssertiondashboardIndexImport
      parentRoute: typeof AuthenticatedAssertionRouteImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedAssertionRouteRouteChildren {
  AuthenticatedAssertionProcessProcessIdRoute: typeof AuthenticatedAssertionProcessProcessIdRoute
  AuthenticatedAssertionReportReportIdRoute: typeof AuthenticatedAssertionReportReportIdRoute
  AuthenticatedAssertiondashboardIndexRoute: typeof AuthenticatedAssertiondashboardIndexRoute
}

const AuthenticatedAssertionRouteRouteChildren: AuthenticatedAssertionRouteRouteChildren =
  {
    AuthenticatedAssertionProcessProcessIdRoute:
      AuthenticatedAssertionProcessProcessIdRoute,
    AuthenticatedAssertionReportReportIdRoute:
      AuthenticatedAssertionReportReportIdRoute,
    AuthenticatedAssertiondashboardIndexRoute:
      AuthenticatedAssertiondashboardIndexRoute,
  }

const AuthenticatedAssertionRouteRouteWithChildren =
  AuthenticatedAssertionRouteRoute._addFileChildren(
    AuthenticatedAssertionRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAssertionRouteRoute: typeof AuthenticatedAssertionRouteRouteWithChildren
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedProcessProcessIdRoute: typeof AuthenticatedProcessProcessIdRoute
  AuthenticatedReportReportIdRoute: typeof AuthenticatedReportReportIdRoute
  AuthenticateddashboardIndexRoute: typeof AuthenticateddashboardIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAssertionRouteRoute:
    AuthenticatedAssertionRouteRouteWithChildren,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedProcessProcessIdRoute: AuthenticatedProcessProcessIdRoute,
  AuthenticatedReportReportIdRoute: AuthenticatedReportReportIdRoute,
  AuthenticateddashboardIndexRoute: AuthenticateddashboardIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteRouteWithChildren
  '/log-in': typeof LogInRoute
  '/assertion': typeof AuthenticatedAssertionRouteRouteWithChildren
  '/reports': typeof AuthenticatedReportsRoute
  '/process/$processId': typeof AuthenticatedProcessProcessIdRoute
  '/report/$reportId': typeof AuthenticatedReportReportIdRoute
  '/': typeof AuthenticateddashboardIndexRoute
  '/assertion/process/$processId': typeof AuthenticatedAssertionProcessProcessIdRoute
  '/assertion/report/$reportId': typeof AuthenticatedAssertionReportReportIdRoute
  '/assertion/': typeof AuthenticatedAssertiondashboardIndexRoute
}

export interface FileRoutesByTo {
  '/log-in': typeof LogInRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/process/$processId': typeof AuthenticatedProcessProcessIdRoute
  '/report/$reportId': typeof AuthenticatedReportReportIdRoute
  '/': typeof AuthenticateddashboardIndexRoute
  '/assertion/process/$processId': typeof AuthenticatedAssertionProcessProcessIdRoute
  '/assertion/report/$reportId': typeof AuthenticatedAssertionReportReportIdRoute
  '/assertion': typeof AuthenticatedAssertiondashboardIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/log-in': typeof LogInRoute
  '/_authenticated/assertion': typeof AuthenticatedAssertionRouteRouteWithChildren
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/process/$processId': typeof AuthenticatedProcessProcessIdRoute
  '/_authenticated/report/$reportId': typeof AuthenticatedReportReportIdRoute
  '/_authenticated/(dashboard)/': typeof AuthenticateddashboardIndexRoute
  '/_authenticated/assertion/process/$processId': typeof AuthenticatedAssertionProcessProcessIdRoute
  '/_authenticated/assertion/report/$reportId': typeof AuthenticatedAssertionReportReportIdRoute
  '/_authenticated/assertion/(dashboard)/': typeof AuthenticatedAssertiondashboardIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/log-in'
    | '/assertion'
    | '/reports'
    | '/process/$processId'
    | '/report/$reportId'
    | '/'
    | '/assertion/process/$processId'
    | '/assertion/report/$reportId'
    | '/assertion/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/log-in'
    | '/reports'
    | '/process/$processId'
    | '/report/$reportId'
    | '/'
    | '/assertion/process/$processId'
    | '/assertion/report/$reportId'
    | '/assertion'
  id:
    | '__root__'
    | '/_authenticated'
    | '/log-in'
    | '/_authenticated/assertion'
    | '/_authenticated/reports'
    | '/_authenticated/process/$processId'
    | '/_authenticated/report/$reportId'
    | '/_authenticated/(dashboard)/'
    | '/_authenticated/assertion/process/$processId'
    | '/_authenticated/assertion/report/$reportId'
    | '/_authenticated/assertion/(dashboard)/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LogInRoute: typeof LogInRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LogInRoute: LogInRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/log-in"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/assertion",
        "/_authenticated/reports",
        "/_authenticated/process/$processId",
        "/_authenticated/report/$reportId",
        "/_authenticated/(dashboard)/"
      ]
    },
    "/log-in": {
      "filePath": "log-in.tsx"
    },
    "/_authenticated/assertion": {
      "filePath": "_authenticated/assertion/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/assertion/process/$processId",
        "/_authenticated/assertion/report/$reportId",
        "/_authenticated/assertion/(dashboard)/"
      ]
    },
    "/_authenticated/reports": {
      "filePath": "_authenticated/reports.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/process/$processId": {
      "filePath": "_authenticated/process/$processId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/report/$reportId": {
      "filePath": "_authenticated/report/$reportId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/(dashboard)/": {
      "filePath": "_authenticated/(dashboard)/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/assertion/process/$processId": {
      "filePath": "_authenticated/assertion/process/$processId.tsx",
      "parent": "/_authenticated/assertion"
    },
    "/_authenticated/assertion/report/$reportId": {
      "filePath": "_authenticated/assertion/report/$reportId.tsx",
      "parent": "/_authenticated/assertion"
    },
    "/_authenticated/assertion/(dashboard)/": {
      "filePath": "_authenticated/assertion/(dashboard)/index.tsx",
      "parent": "/_authenticated/assertion"
    }
  }
}
ROUTE_MANIFEST_END */
